import React, { useState } from "react";
import { Row, Col, Typography, Form, Input, Button, message } from "antd";
import 'antd/dist/antd.min.css';
import {
  EnvironmentOutlined,
  MailOutlined,
  PhoneOutlined,
  LinkedinOutlined,
} from "@ant-design/icons";
import HttpService from "../../services/HttpService";
const { Title } = Typography;
const ContactComponent = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const httpService = new HttpService();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        ...values,
        form_type: 'Read mark'
      };
      const client = 'Qmj9xe8C358JRid6rWfl80b1V2jpCvhvCovKih1d';
      const response = await httpService.postDataClient(payload, 'contact_request_product', client);
      console.log('API response:', response);
      message.success('Message sent successfully!');
      form.resetFields();
    } catch (error) {
      console.error('Error sending message:', error);
      message.error('Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const infoCardStyle = {
    textAlign: "center",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    padding: "18px 16px",
    background: "#fafafa",
    width: "160px",
    display: "inline-block",
    margin: "0 8px",
  };

  const iconStyle = {
    fontSize: "20px",
    color: "#333",
    marginBottom: "8px",
    display: "block",
  };

  return (
    <div style={{ width: "100%", padding: "50px 20px", background: "#fff" }}>
      <Row justify="center" style={{ marginBottom: "10px" }}>
        <Col xs={24} md={16} xl={14} style={{ textAlign: "center" }}>
          <Title style={{ marginBottom: "10px", color: "#1a1a1a" }}>Contact Us</Title>
          <p style={{ color: "#667085", fontSize: "15px", lineHeight: "1.6" }}>
            Reach out to us for any inquiries, support, or feedback. Our team is here to assist you.
            Get in touch through phone, email, or our contact form. We're ready to help!
          </p>
        </Col>
      </Row>

      <div style={{ textAlign: "center", marginBottom: "40px", marginTop: "30px" }}>
        <div style={infoCardStyle}>
          <MailOutlined style={iconStyle} />
          <p style={{ color: "#F6921E", margin: 0, fontSize: "13px" }}>support@abhyaas.in</p>
        </div>
        <div style={infoCardStyle}>
          <PhoneOutlined style={iconStyle} />
          <p style={{ color: "#555", margin: 0, fontSize: "13px" }}>+91 83416 80090</p>
        </div>
        <div style={infoCardStyle}>
          <EnvironmentOutlined style={iconStyle} />
          <p style={{ color: "#555", margin: 0, fontSize: "13px" }}>Hyderabad, India</p>
        </div>
        <a href="https://www.linkedin.com/showcase/abhyaas-edmark" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
          <div style={infoCardStyle}>
            <LinkedinOutlined style={iconStyle} />
            <p style={{ color: "#555", margin: 0, fontSize: "13px" }}>Social Profile</p>
          </div>
        </a>
      </div>

      <Row justify="center">
        <Col xs={24} md={16} xl={14}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            requiredMark={false}
          >
            <Form.Item
              label={<span style={{ color: "#333" }}><span style={{ color: "#F6921E", marginRight: "4px" }}>*</span>Full Name</span>}
              name="name"
              rules={[{ required: true, message: 'Please enter your full name' }]}
            >
              <Input placeholder="Eg., Mr. Arjun" style={{ borderColor: "#d9d9d9", color: "#aaa" }} />
            </Form.Item>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  label={<span style={{ color: "#333" }}><span style={{ color: "#F6921E", marginRight: "4px" }}>*</span>E-mail</span>}
                  name="email"
                  rules={[
                    { required: true, message: 'Please enter your email' },
                    { type: 'email', message: 'Please enter a valid email' }
                  ]}
                >
                  <Input placeholder="Eg., something@example.com" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label={<span style={{ color: "#333" }}><span style={{ color: "#F6921E", marginRight: "4px" }}>*</span>Phone</span>}
                  name="phone_number"
                  rules={[{ required: true, message: 'Please enter your phone number' }]}
                >
                  <Input placeholder="XXX XXX XXXXXX" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  label={<span style={{ color: "#333" }}>Company Name</span>}
                  name="company"
                >
                  <Input placeholder="Eg., Edmark" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label={<span style={{ color: "#333" }}>Website</span>}
                  name="website"
                >
                  <Input placeholder="Eg., www.edmark.in" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              label={<span style={{ color: "#333" }}>Message</span>}
              name="message"
            >
              <Input.TextArea rows={5} placeholder="Enter something..." />
            </Form.Item>
            <Form.Item style={{ textAlign: "center", marginTop: "10px" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{
                  backgroundColor: "#F6921E",
                  borderColor: "#F6921E",
                  minWidth: "180px",
                  height: "42px",
                  fontSize: "15px",
                  fontWeight: "600",
                  borderRadius: "4px",
                }}
              >
                Send A Message
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default ContactComponent;
